// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-register[data-v-4e257057]{position:relative}.base-register__badge[data-v-4e257057]{position:absolute;z-index:1;top:0;right:12px;transform:translateY(-50%)}.base-register__button[data-v-4e257057]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
